import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

type HypothesisData = { text?: string } | null;

const HypothesisChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as HypothesisData;
  const newValue = change.newValue as HypothesisData;

  return (
    <ActivityItem.Section label="Updated hypothesis">
      <ActivityTagItem
        oldValue={oldValue?.text ?? undefined}
        newValue={newValue?.text ?? undefined}
      />
    </ActivityItem.Section>
  );
};

export const HYPOTHESIS_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension(
  {
    id: 'reanalysis-hypothesis-change',
    predicate: ({ change }) => change.fieldPath === '/module_data/hypothesis',
    render: HypothesisChangeRender,
  },
);
